export default __webpack_public_path__ + "static/media/location.252f8019.svg";